var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardCustomerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 41,
    viewBox: "0 0 247 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.874 35.788C247.055 36.3101 246.778 36.8794 246.256 37.0597L237.749 39.9975C237.227 40.1778 236.657 39.9008 236.477 39.3787C236.297 38.8567 236.574 38.2874 237.096 38.1071L244.658 35.4957L242.046 27.9339C241.866 27.4119 242.143 26.8425 242.665 26.6622C243.187 26.482 243.756 26.759 243.937 27.281L246.874 35.788ZM245.492 37.0137C195.632 12.7514 157.498 1.56924 120.427 2.01267C83.3528 2.45613 47.2206 14.5275 1.35768 37.0124L0.47728 35.2166C46.4384 12.6835 82.8885 0.461541 120.403 0.0128155C157.919 -0.435938 196.379 10.8909 246.367 35.2153L245.492 37.0137Z",
    fill: "#F4B652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomerArrow);
export default __webpack_public_path__ + "static/media/dashboard_customer_arrow.79bbe1e73b3411243aafb42deea1d2d4.svg";
export { ForwardRef as ReactComponent };